import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import { EstadoInterface, MunicipioInterface } from "../../interfaces";
import auxService from "../../services/AuxService";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck, faEye, faEyeSlash, faSave } from "@fortawesome/free-solid-svg-icons";
import { CamposObrigatorios, MakeMessageError } from "../../components/Components";
import { rgx_numberOnly } from "../../utils/utils";
import InputMask from 'react-input-mask';
import { TermoUsoModal } from "../assinatura/TermoUsoModal";
import { useQuestion } from "../../components/ModalQuestion/useModalQuestion";


interface UsuarioForm {
    email: string;
    password: string;
    name: string;
    cpfcnpj: string;
    ie: string;
    name_empresa: string;
    name_fantasia: string;
    logradouro: string;
    numero: string;
    bairro: string;
    cep: string;
    complemento: string;
    estado_id: number;
    municipio_id: number;
    fone: string;
    celular: string;
    aceite: boolean;
}

const initial = {
    email: '',
    password: '',
    name: '',
    cpfcnpj: '',
    name_empresa: '',
    name_fantasia: '',
    logradouro: '',
    numero: '',
    bairro: '',
    cep: '',
    complemento: '',
    estado_id: 0,
    municipio_id: 0,
    fone: '',
    celular: '',
    ie: '',
    aceite: false
}

const initialFieldsError = {
    name: [],
    email: [],
    password: [],
    cpfcnpj: [],
    name_empresa: [],
    name_fantasia: [],
    logradouro: [],
    numero: [],
    cep: [],
    complemento: [],
    bairro: [],
    estado_id: [],
    municipio_id: [],
    fone: [],
    celular: [],
    ie: []

}

export default function RegisterForm() {
    const [usuarioForm, setUsuarioForm] = useState<UsuarioForm>(initial);
    const [municipios, setMunicipios] = useState<MunicipioInterface[]>([]);
    const municipioRef = useRef<HTMLSelectElement>(null);
    const [errors, setErrors] = useState(initialFieldsError);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const btnRegister = useRef<HTMLButtonElement>(null);
    const [aceite, setAceite] = useState<boolean>(false);
    const [showTermo, setShowTermo] = useState<boolean>(false);
    const { confirm, ConfirmModal } = useQuestion();


    const handleAceite = () => {
        setAceite(true);
        setUsuarioForm({ ...usuarioForm, aceite: true });
        setShowTermo(false);
    }

    useEffect(() => {
        auxService.getEstados().then(data => {
            setEstados([...estados, ...data])
        })
        municipioRef.current?.setAttribute('disabled', '');
    }, [])

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setErrors({
            ...errors,
            [name]: ""
        })

        const transformers: Record<string, (val: string) => string> = {
            cpfcnpj: rgx_numberOnly,
            ie: rgx_numberOnly,
            cep: rgx_numberOnly,
        };

        const newValue = transformers[name] ? transformers[name](value) : value;

        setUsuarioForm((prev) => ({
            ...prev,
            [name]: newValue
        }))
    }

    const [estados, setEstados] = useState<EstadoInterface[]>([{
        id: 0,
        uf: 'Selecione',
        name: 'Selecione',
        cod_ibge: 0,
        pais: { name: 'Brasil' }

    }]);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        btnRegister.current?.setAttribute('disabled', 'disabled');
        await auxService.postRegister(usuarioForm).then(async data => {
            const confirmed = await confirm({
                title: 'Sucesso!',
                message: 'Registro efeturado com sucesso. Faço o login para continuar!',
                btnConfirmOptions: {
                    icon: faCheck,
                    title: 'OK',
                    variant: 'success'
                }
            })
            if (confirmed) {
                btnRegister.current?.removeAttribute('disabled');
                navigate('/login')
            }

        }).catch(err => {
            btnRegister.current?.removeAttribute('disabled');
            if (err.response.status === 422) {
                setErrors(err.response.data)
            }
        })
    };

    const handleChangeEstado = (e: any) => {
        const { name, value } = e.target;
        municipioRef.current?.setAttribute('disabled', '');

        setErrors({
            ...errors,
            [name]: "",
            municipio_id: []
        })

        if (value > 0) {
            auxService.getMunicipios(value).then(data => {

                if (data?.length > 0) {
                    setMunicipios(data)
                    setUsuarioForm((prev) => ({
                        ...prev,
                        municipio_id: data.filter((municipio: MunicipioInterface) =>
                            municipio.capital === 1)[0]?.id || 0
                    }))
                    municipioRef.current?.removeAttribute('disabled');
                }
            }).catch(err => {
                municipioRef.current?.removeAttribute('disabled');
            })
        } else {
            municipioRef.current?.setAttribute('disabled', '');

            setMunicipios([])
            setUsuarioForm((prev) => ({
                ...prev,
                municipio_id: 0
            }))
        }

        setUsuarioForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    return (
        <div className="container-fluid mt-2 d-flex justify-content-center align-items-center">
            <div className="col">
                {showTermo && (

                    <TermoUsoModal
                        show={showTermo}
                        aceite={aceite}
                        onHide={() => setShowTermo(false)}
                        handleAceite={handleAceite} />
                )}


                <Form onSubmit={handleSubmit} noValidate>
                    <Card className="card-success card-outline">
                        <Card.Header>
                            <h4 className="text-center mb-0 text-muted">REGISTRO</h4>
                        </Card.Header>
                        <Card.Body>
                            <fieldset className="group-box">
                                <legend>Dados do usuário</legend>
                                <Row className="g-2">
                                    <Col md>
                                        <Form.Group className="mb-3" controlId="name">
                                            <Form.Label>* Nome do usuário:</Form.Label>
                                            <Form.Control type="text" name="name"
                                                className={`${errors.name?.length > 0 ? "is-invalid" : ""}`}
                                                value={usuarioForm.name}
                                                maxLength={60}
                                                onChange={handleChange} autoFocus />
                                            <MakeMessageError errors={errors} field="name" />
                                        </Form.Group>
                                    </Col>
                                    <Col md>
                                        <Form.Group className="mb-3" controlId="email">
                                            <Form.Label>* E-mail:</Form.Label>
                                            <Form.Control type="email" name="email"
                                                value={usuarioForm.email}
                                                className={`${errors.email?.length > 0 ? "is-invalid" : ""}`}
                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="email" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="password">
                                            <Form.Label>* Senha:</Form.Label>
                                            <InputGroup>

                                                <Form.Control
                                                    type={showPassword ? "text" : "password"}
                                                    name="password"
                                                    className={`border-end-0 
                                                        ${errors.password?.length > 0 ? "is-invalid" : ""}
                                                    `}
                                                    value={usuarioForm.password}
                                                    maxLength={60}
                                                    onChange={handleChange} />

                                                <span className={
                                                    `input-group-text border-start-0 bg-white 
                                                    ${errors.password?.length > 0 ? "border-danger" : ""
                                                    }`
                                                } >
                                                    <Link to={''} onClick={(e) => {
                                                        e.preventDefault();
                                                        setShowPassword(!showPassword);
                                                    }}>
                                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                                    </Link>
                                                </span>
                                            </InputGroup>
                                            <MakeMessageError errors={errors} field="password" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </fieldset>

                            <fieldset className="group-box">
                                <legend>Dados da empresa</legend>
                                <Row className="g-2">
                                    <Col md>
                                        <Form.Group className="mb-3" controlId="name_empresa  ">
                                            <Form.Label>* Nome / Razão Social:</Form.Label>
                                            <Form.Control type="text" name="name_empresa"
                                                value={usuarioForm.name_empresa}
                                                className={`${errors.name_empresa?.length > 0 ? "is-invalid" : ""}`}
                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="name_empresa" />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="name_fantasia  ">
                                            <Form.Label>Nome fantasia:</Form.Label>
                                            <Form.Control type="text" name="name_fantasia"
                                                value={usuarioForm.name_fantasia}
                                                className={`${errors.name_fantasia?.length > 0 ? "is-invalid" : ""}`}
                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="name_fantasia" />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group className="mb-3" controlId="cpfcnpj  ">
                                            <Form.Label>* CNPJ:</Form.Label>
                                            <Form.Control type="text" name="cpfcnpj"
                                                value={usuarioForm.cpfcnpj}
                                                className={`${errors.cpfcnpj?.length > 0 ? "is-invalid" : ""}`}
                                                maxLength={14}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="cpfcnpj" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group className="mb-3" controlId="ie">
                                            <Form.Label>* Inscrição Estadual:</Form.Label>
                                            <Form.Control type="text" name="ie"
                                                value={usuarioForm.ie}
                                                className={`${errors.ie?.length > 0 ? "is-invalid" : ""}`}
                                                maxLength={14}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="ie" />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="g-2">
                                    <Col md>
                                        <Form.Group className="mb-3" controlId="logradouro">
                                            <Form.Label>* Logradouro:</Form.Label>
                                            <Form.Control type="text" name="logradouro"
                                                value={usuarioForm.logradouro}
                                                className={`${errors.logradouro?.length > 0 ? "is-invalid" : ""}`}
                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="logradouro" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="numero">
                                            <Form.Label>* Número:</Form.Label>
                                            <Form.Control type="text" name="numero"
                                                value={usuarioForm.numero}
                                                className={`${errors.numero?.length > 0 ? "is-invalid" : ""}`}
                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="numero" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group className="mb-3" controlId="cep">
                                            <Form.Label>* CEP:</Form.Label>
                                            <Form.Control type="text" name="cep"
                                                value={usuarioForm.cep}
                                                className={`${errors.cep?.length > 0 ? "is-invalid" : ""}`}
                                                maxLength={8}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="cep" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="g-2">

                                    <Col md>
                                        <Form.Group className="mb-3" controlId="complemento">
                                            <Form.Label>Complemento:</Form.Label>
                                            <Form.Control type="text" name="complemento"
                                                value={usuarioForm.complemento}
                                                className={`${errors.complemento?.length > 0 ? "is-invalid" : ""}`}
                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="complemento" />
                                        </Form.Group>
                                    </Col>

                                    <Col md>
                                        <Form.Group className="mb-3" controlId="bairro">
                                            <Form.Label>* Bairro:</Form.Label>
                                            <Form.Control type="text" name="bairro"
                                                value={usuarioForm.bairro}
                                                className={`${errors.bairro?.length > 0 ? "is-invalid" : ""}`}
                                                maxLength={60}
                                                onChange={handleChange} />
                                            <MakeMessageError errors={errors} field="bairro" />
                                        </Form.Group>
                                    </Col>



                                    <Col md={2}>
                                        <Form.Group className="mb-3" controlId="fone">
                                            <Form.Label>Telefone:</Form.Label>
                                            <InputMask mask="(99)9999-9999" name="fone"
                                                className={`form-control ${errors.fone?.length > 0 ?
                                                    "is-invalid" : ""}`
                                                }
                                                value={usuarioForm.fone}
                                                onChange={handleChange}
                                            />
                                            <MakeMessageError errors={errors} field="fone" />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group className="mb-3" controlId="celular">
                                            <Form.Label>* Celular:</Form.Label>
                                            <InputMask mask="(99)99999-9999" name="celular"
                                                className={`form-control ${errors.celular?.length > 0 ?
                                                    "is-invalid" : ""}`
                                                }
                                                value={usuarioForm.celular}
                                                onChange={handleChange}
                                            />
                                            <MakeMessageError errors={errors} field="celular" />
                                        </Form.Group>
                                    </Col>

                                </Row>
                                <Row className="g-2">
                                    <Col md={2}>
                                        <Form.Group className="mb-3" controlId="estado_id">
                                            <Form.Label>* Estados</Form.Label>
                                            <Form.Select name="estado_id" value={usuarioForm.estado_id}
                                                className={`${errors.estado_id?.length > 0 ? "is-invalid" : ""}`}
                                                onChange={handleChangeEstado}>

                                                {estados.map((estado) => (
                                                    <option key={estado.id} value={estado.id}>{estado.uf}</option>
                                                ))}
                                            </Form.Select>
                                            <MakeMessageError errors={errors} field="estado_id" />
                                        </Form.Group>
                                    </Col>


                                    <Col md>
                                        <Form.Group className="mb-3" controlId="municipio_id">
                                            <Form.Label>* Municípios</Form.Label>
                                            <Form.Select name="municipio_id" value={usuarioForm.municipio_id}
                                                ref={municipioRef}
                                                className={`${errors.municipio_id?.length > 0 ? "is-invalid" : ""}`}
                                                onChange={handleChange}>
                                                {municipios && (
                                                    municipios?.map((municipio) => {
                                                        return <option
                                                            selected={municipio.capital === 1} key={municipio.id}
                                                            value={municipio.id}>{municipio.name}
                                                        </option>
                                                    })
                                                )}
                                            </Form.Select>
                                            <MakeMessageError errors={errors} field="municipio_id" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </fieldset>
                            <CamposObrigatorios />

                        </Card.Body>
                        <Card.Footer>
                            <div className="g-2 d-flex justify-content-between">
                                <Col md>
                                    <Link className="btn btn-secondary" to="/">
                                        <FontAwesomeIcon className="me-1" icon={faArrowLeft} /> Voltar
                                    </Link>
                                </Col>
                                <Col md={'auto'}>
                                    {aceite ? (
                                        <Button type="submit" ref={btnRegister}>
                                            <FontAwesomeIcon icon={faSave} className="me-1" /> Registrar
                                        </Button>
                                    ) : (
                                        <Button variant="success" onClick={() => setShowTermo(true)}>
                                            Aceitar termos
                                        </Button>
                                    )}
                                </Col>
                            </div>
                        </Card.Footer>
                    </Card>
                </Form>
            </div>
            {ConfirmModal}
        </div>
    )
}